var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c("div"),
      _c(
        "div",
        { staticClass: "search-contain" },
        [
          _c(
            "el-form",
            {
              ref: "query",
              attrs: { model: _vm.query, inline: true, size: "mini" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.activeSource === 4 ? "icon名称" : "广告名称",
                  },
                },
                [
                  _c("el-input", {
                    directives: [
                      { name: "no-emoji", rawName: "v-no-emoji" },
                      { name: "no-space", rawName: "v-no-space" },
                    ],
                    attrs: { placeholder: "请输入名称", clearable: "" },
                    model: {
                      value: _vm.query.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "name", $$v)
                      },
                      expression: "query.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    _vm._l(_vm.statusList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动时间", prop: "daterange" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.daterange,
                      callback: function ($$v) {
                        _vm.daterange = $$v
                      },
                      expression: "daterange",
                    },
                  }),
                ],
                1
              ),
              _vm.activeSource === 5 || _vm.activeSource === 4
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.activeSource === 4 ? "排序" : "权重",
                        prop: "sort",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.query.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "sort", $$v)
                            },
                            expression: "query.sort",
                          },
                        },
                        _vm._l(_vm.sortList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.value, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "创建人" } },
                [
                  _c("el-input", {
                    directives: [{ name: "no-emoji", rawName: "v-no-emoji" }],
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.query.createUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "createUser", $$v)
                      },
                      expression: "query.createUser",
                    },
                  }),
                ],
                1
              ),
              _vm.activeSource === 5 ||
              _vm.activeSource === 4 ||
              _vm.activeSource === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "地区" } },
                    [
                      _c("YdCitySelect", {
                        attrs: {
                          mode: "1",
                          placeholder: "请选择地级归属",
                          customHttp: _vm.getDriverAreaTree,
                          fieldFormat: _vm.fieldFormat,
                        },
                        model: {
                          value: _vm.query.areaId,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "areaId", $$v)
                          },
                          expression: "query.areaId",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeSource === 5
                ? _c(
                    "el-form-item",
                    { attrs: { label: "展示页面" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.query.displayPage,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "displayPage", $$v)
                            },
                            expression: "query.displayPage",
                          },
                        },
                        _vm._l(_vm.displayPageList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchChange },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchReset },
                    },
                    [_vm._v("清空")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["user_advertising_edit"],
                          expression: "['user_advertising_edit']",
                        },
                      ],
                      staticClass: "add",
                      staticStyle: { "margin-right": "40px" },
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.addClick },
                    },
                    [_vm._v("新增")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.activeSource === 4
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["usr_layout_configuration"],
                      expression: "['usr_layout_configuration']",
                    },
                  ],
                  staticClass: "layoutConfig",
                  staticStyle: { "margin-right": "40px" },
                  on: { click: _vm.addConfig },
                },
                [_vm._v("布局配置")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "yd-table",
        {
          ref: "advertisingTable",
          attrs: {
            data: _vm.records,
            pagination: _vm.pagination,
            loading: _vm.loading,
          },
          on: { onChange: _vm.onTableChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.activeSource === 4 ? "icon名称" : "广告名称",
              prop: "name",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.activeSource !== 5
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.activeSource === 4 ? "位置" : "广告位置",
                  prop: "locationDesc",
                  align: "center",
                  width: "150",
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            key: "sort",
            attrs: {
              label: _vm.activeSource === 4 ? "排序" : "权重",
              prop: "sort",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "图片", prop: "imgUrl", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.activeSource === 4 || _vm.activeSource === 2
                      ? _c("el-image", {
                          staticStyle: { width: "40px", height: "40px" },
                          attrs: {
                            src: scope.row.imgUrl,
                            "preview-src-list": [scope.row.imgUrl],
                          },
                        })
                      : _c("el-image", {
                          staticStyle: { width: "50px", height: "40px" },
                          attrs: {
                            src: scope.row.imgUrl,
                            "preview-src-list": [scope.row.imgUrl],
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm.activeSource === 5
            ? _c("el-table-column", {
                attrs: {
                  label: "展示页面",
                  prop: "displayPageName",
                  align: "center",
                  width: "150",
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              label: "展示渠道",
              prop: "displayChannel",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(_vm._s(row.displayChannel || "-"))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "展示地区",
              prop: "location",
              align: "center",
              width: "200px",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "180px",
                          "white-space": "nowrap",
                          "text-overflow": "ellipsis",
                          overflow: "hidden",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(row.areaNames ? row.areaNames.join(",") : "")
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.activeSource === 5
            ? _c("el-table-column", {
                attrs: {
                  label: "状态",
                  prop: "status",
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            { class: ["status-text", "status-" + row.status] },
                            [_vm._v(_vm._s(_vm.statusTitle(row)))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2536693971
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "开始时间", prop: "startTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", prop: "endTime", align: "center" },
          }),
          _vm.activeSource === 4
            ? _c("el-table-column", {
                attrs: {
                  label: "状态",
                  prop: "statusStr",
                  align: "center",
                  width: "100",
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              prop: "operate",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status !== 4 || _vm.activeSource === 4
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_edit"],
                                expression: "['user_advertising_edit']",
                              },
                            ],
                            staticClass: "info-button",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.getAdvertisingInfo(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    scope.row.status == 5 && _vm.activeSource !== 4
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_status"],
                                expression: "['user_advertising_status']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleStart(scope.row)
                              },
                            },
                          },
                          [_vm._v("上架")]
                        )
                      : _vm._e(),
                    scope.row.status == 1 && _vm.activeSource !== 4
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_review"],
                                expression: "['user_advertising_review']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleApprove(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("通过")]
                        )
                      : _vm._e(),
                    scope.row.status == 1 && _vm.activeSource !== 4
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_review"],
                                expression: "['user_advertising_review']",
                              },
                            ],
                            staticClass: "danger-button",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleFailed(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("不通过")]
                        )
                      : _vm._e(),
                    scope.row.status == 4 && _vm.activeSource !== 4
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_status"],
                                expression: "['user_advertising_status']",
                              },
                            ],
                            staticClass: "danger-button",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleFinish(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("下架")]
                        )
                      : _vm._e(),
                    scope.row.status > 3
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_data"],
                                expression: "['user_advertising_data']",
                              },
                            ],
                            staticClass: "primary-button",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.dataView(scope.row)
                              },
                            },
                          },
                          [_vm._v("数据")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.editVisible
        ? _c("advertising-edit", {
            attrs: {
              visible: _vm.editVisible,
              title: _vm.title,
              locationList: _vm.locationList,
              type: _vm.activeSource,
              clientType: _vm.clientType,
              advertisingInfo: _vm.advertisingInfo,
            },
            on: { saveEdit: _vm.saveEdit, closeEdit: _vm.closeEdit },
          })
        : _vm._e(),
      _c("data-view", { ref: "dataView" }),
      _c("advertising-detail", { ref: "advertisingDetail" }),
      _c(
        "YDCommonDialog",
        _vm._b(
          {
            attrs: { show: _vm.dialog.show },
            on: {
              "update:show": function ($event) {
                return _vm.$set(_vm.dialog, "show", $event)
              },
              submit: _vm.dialog.onSubmit,
            },
          },
          "YDCommonDialog",
          _vm.dialog,
          false
        ),
        [
          _vm.dialog.show
            ? _c(
                _vm.dialog.tag,
                _vm._b(
                  {
                    ref: "panel",
                    tag: "component",
                    attrs: { loading: _vm.dialog.loading, title: "" },
                    model: {
                      value: _vm.modelData,
                      callback: function ($$v) {
                        _vm.modelData = $$v
                      },
                      expression: "modelData",
                    },
                  },
                  "component",
                  _vm.dialog,
                  false
                )
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }